module.exports = __webpack_public_path__ + "img/c05_buildingtechcivilengineering_Normal_ua.a0a390de.webp";